module.exports = __webpack_public_path__ + "img/tsumugi_4.4885e4fa.png";